import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCgtFwUHBBEB3orRol769guQ_0Q5B8CTeU",
  authDomain: "custom-todo.firebaseapp.com",
  databaseURL: "https://custom-todo-default-rtdb.firebaseio.com",
  projectId: "custom-todo",
  storageBucket: "custom-todo.appspot.com",
  messagingSenderId: "513833588344",
  appId: "1:513833588344:web:3ba7509bda7563df1ebf8d",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const database = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebaseApp.storage();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, storage };
export default database;
